import { render, staticRenderFns } from "./DeviceView.vue?vue&type=template&id=3897d561&"
import script from "./DeviceView.vue?vue&type=script&lang=js&"
export * from "./DeviceView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports